import { render, staticRenderFns } from "./shopWlMsg.vue?vue&type=template&id=35f9beba&scoped=true"
import script from "./shopWlMsg.vue?vue&type=script&lang=js"
export * from "./shopWlMsg.vue?vue&type=script&lang=js"
import style0 from "./shopWlMsg.vue?vue&type=style&index=0&id=35f9beba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35f9beba",
  null
  
)

export default component.exports